import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Table, Button, Icon, ColumnType, ContentPosition, } from '@doxyme/ui';
import { calculateDirection } from '../../accessors';
import { getLocationName } from '../../helpers/get-location-name';
export var LocationTableFields;
(function (LocationTableFields) {
    LocationTableFields["NAME"] = "name";
    LocationTableFields["COUNT_PROVIDERS"] = "countProviders";
    LocationTableFields["COUNT_ROOMS"] = "countRooms";
})(LocationTableFields || (LocationTableFields = {}));
export const LocationsTable = ({ data, onItemDelete, onItemEdit, onSort, }) => {
    const intl = useIntl();
    const columns = [
        {
            id: 1,
            title: intl.formatMessage({
                id: 'account.settings.locations.table.locations',
            }),
            type: ColumnType.COMPONENT,
            classNamesForCell: () => 'locations__table_cell',
            directionSetter: calculateDirection(LocationTableFields.NAME),
            sortingChanged: (direction) => onSort({ field: LocationTableFields.NAME, direction }),
            columnRenderer: (location) => {
                const locationName = getLocationName(location);
                return <div>{locationName}</div>;
            },
            isSortingAvailable: true,
        },
        {
            id: 2,
            title: intl.formatMessage({
                id: 'account.settings.locations.table.users',
            }),
            type: ColumnType.COMPONENT,
            contentPosition: ContentPosition.CENTER,
            classNamesForCell: () => 'locations__table_cell_providers',
            directionSetter: calculateDirection(LocationTableFields.COUNT_PROVIDERS),
            sortingChanged: (direction) => onSort({ field: LocationTableFields.COUNT_PROVIDERS, direction }),
            columnRenderer: (location) => (<div>{location.countProviders}</div>),
            isSortingAvailable: true,
        },
        {
            id: 3,
            title: intl.formatMessage({
                id: 'account.settings.locations.table.shared-rooms',
            }),
            type: ColumnType.COMPONENT,
            contentPosition: ContentPosition.CENTER,
            classNamesForCell: () => 'locations__table_cell_rooms',
            directionSetter: calculateDirection(LocationTableFields.COUNT_ROOMS),
            sortingChanged: (direction) => onSort({ field: LocationTableFields.COUNT_ROOMS, direction }),
            columnRenderer: (location) => (<div>{location.countRooms}</div>),
            isSortingAvailable: true,
        },
        {
            id: 4,
            title: '',
            type: ColumnType.COMPONENT,
            contentPosition: ContentPosition.CENTER,
            classNamesForCell: () => 'locations__table_cell_manage-location',
            columnRenderer: (location) => (<Button btnStyle="flat" size="small" onClick={() => onItemEdit(location)} noHover={true}>
          <FormattedMessage id="account.settings.locations.table.manage-location"/>
        </Button>),
        },
        {
            id: 5,
            title: '',
            type: ColumnType.COMPONENT,
            contentPosition: ContentPosition.RIGHT,
            classNamesForCell: () => 'locations__table_cell_delete',
            columnRenderer: ({ isDefault, id }) => {
                return (!isDefault && (<Button iconOnly={true} btnStyle="flat" size="small" onClick={() => onItemDelete(id)}>
              <Icon name="delete" size="x-small"/>
            </Button>));
            },
        },
    ];
    return <Table className="locations__table" columns={columns} body={data}/>;
};
